/* eslint-disable no-console */
import { put, call, select } from 'redux-saga/effects';
import { cloneDeep, map, findIndex, get } from 'lodash';

import {
  findTemplateById,
  getModuleTemplates,
  fetchHubsWithSurvey,
  addNewSurveyTemplate,
  updateSurveyTemplate,
  deleteSurveyTemplateById, 
} from '../../../api';
import history from '../../../history';

import { POPUP_ALERT } from '../../../actions/alert';

import { setData, getSurveyProvisioningState, setLoading } from '../actions';

export function* fetchModuleTemplates({ data: params = {} }) {
  try {
    const { page = 1 } = params;
    yield put(setLoading({ listing: true }));
    const { pagination } = yield select(getSurveyProvisioningState);
    const {
      data: { templates, pagination: paginationData },
    } = yield call(getModuleTemplates, { ...pagination, current: page, type: 'survey' });
    const templateData = map(templates, t => ({ ...t, key: t.id }));
    yield put(setData({ templates: templateData, pagination: paginationData }));
  } catch (e) {
    console.log(e);
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Error fetching templates' },
    });
  }
  yield put(setLoading({ listing: undefined }));
}

export function* getHubsSurveyList() {
  try {
    yield put(setLoading({ survey_list: true }));
    const { data } = yield call(fetchHubsWithSurvey);
    yield put(setData({ hubsSurveys: data.data, hubList: data.hubsWithSurveysEnabled }));
  } catch (e) {
    console.log(e);
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Error fetching survey list' },
    });
  }
  yield put(setLoading({ survey_list: undefined }));
}

export function* addNewTemplateSaga({ data }) {
  try {
    const { templates } = yield select(getSurveyProvisioningState);
    const clonedTemplates = cloneDeep(templates);
    if (data.id) {
      const { data: newTemplate } = yield call(updateSurveyTemplate, {
        formData: data,
      });
      const index = findIndex(clonedTemplates, { id: data.id });
      if (index !== -1) {
        clonedTemplates.splice(index, 1, newTemplate.data);
      }
    } else {
      const { data: newTemplate } = yield call(addNewSurveyTemplate, {
        formData: data,
      });
      clonedTemplates.unshift(newTemplate.data);
    }
    yield put(
      setData({
        templates: clonedTemplates,
        showSurveyForm: false,
        surveyData: undefined,
        singleTemplate: undefined,
        preSelectedHubs: [],
      })
    );
    yield put({
      type: POPUP_ALERT,
      data: {
        type: 'success',
        message: data.id ? `Template Updated` : 'New Template Added',
      },
    });
    history.push('/survey-provisioning');
  } catch (e) {
    console.log(e);
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Error adding new survey template' },
    });
  }
}

export function* fetchTemplateToEdit({ data: params = {} }) {
  try {
    const { templateId } = params;
    yield put(setLoading({ edit_template: true }));
    const {
      data: { template },
    } = yield call(findTemplateById, {
      templateId,
    });
    const toUpdate = {
      singleTemplate: {
        ...template,
        title: get(template, 'template.title'),
        description: get(template, 'template.description'),
        link: get(template, 'link'),
      },
    };
    toUpdate.showSurveyForm = true;
    toUpdate.preSelectedHubs = get(template, 'setting.launch_in.hubs', []);
    toUpdate.surveyData = {
      hubId: get(template, ['setting', 'hubId']),
      surveyId: get(template, ['setting', 'surveyId']),
    };
    yield put(setData(toUpdate));
  } catch (e) {
    console.log(e);
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Error fetching template' },
    });
  }
  yield put(setLoading({ edit_template: undefined }));
}
export function* deleteTemplateSaga({ data }) {
  try {
    const { templateId } = data;
    yield put(setLoading({ deleting: true }));
    yield call(deleteSurveyTemplateById, templateId);
    const { templates } = yield select(getSurveyProvisioningState);
    const clonedTemplates = cloneDeep(templates);
    const index = findIndex(clonedTemplates, { id: templateId });
    if (index !== -1) {
      clonedTemplates.splice(index, 1);
      yield put(
        setData({
          templates: clonedTemplates,
          showSurveyForm: false,
          surveyData: undefined,
          singleTemplate: undefined,
        })
      );
    }
    yield put({
      type: POPUP_ALERT,
      data: {
        type: 'success',
        message: `Survey Template Deleted!`,
      },
    });
    history.push('/survey-provisioning');
  } catch (e) {
    console.log(e);
    yield put({
      type: POPUP_ALERT,
      data: { type: 'error', message: 'Error deleting template' },
    });
  }
  yield put(setLoading({ deleting: undefined }));
}
